import { render, staticRenderFns } from "./ConfigUser.vue?vue&type=template&id=5f9b137b&scoped=true"
import script from "./ConfigUser.vue?vue&type=script&lang=js"
export * from "./ConfigUser.vue?vue&type=script&lang=js"
import style0 from "./ConfigUser.vue?vue&type=style&index=0&id=5f9b137b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b137b",
  null
  
)

export default component.exports